function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "camper"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M29.36,14.82,24.5,8.34A3.33,3.33,0,0,0,21.83,7H4.41A2.41,2.41,0,0,0,2,9.41V11a1,1,0,0,0,2,0V9.41A.42.42,0,0,1,4.41,9H21.83a1.33,1.33,0,0,1,1.07.54l.35.46H16a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h9a1,1,0,0,0,0-2H17V12h7.75l3,4a1.13,1.13,0,0,1,.24.71v6.55a.73.73,0,0,1-.72.72h-.63a3.48,3.48,0,0,0-6.3,0h-8.7a3.48,3.48,0,0,0-6.3,0H4.72A.73.73,0,0,1,4,23.28V15a1,1,0,0,0-2,0v8.28A2.72,2.72,0,0,0,4.72,26h.33A3.48,3.48,0,0,0,12,26h8.1A3.48,3.48,0,0,0,27,26h.33A2.72,2.72,0,0,0,30,23.28V16.73A3.18,3.18,0,0,0,29.36,14.82ZM8.5,27A1.5,1.5,0,0,1,7,25.5a1.53,1.53,0,0,1,0-.3A1.5,1.5,0,1,1,8.5,27Zm15,0A1.5,1.5,0,0,1,22,25.5a1.45,1.45,0,0,1,0-.3A1.5,1.5,0,1,1,23.5,27Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M13,18a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1ZM7,12h5v4H7Z"
}));

var SvgCamper = function SvgCamper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camper.741751e2.svg";
export { ForwardRef as ReactComponent };